import type { Instance, SnapshotOut } from 'mobx-state-tree'
import { getSnapshot, types } from 'mobx-state-tree'

import type { Asset, AssetTracker } from '../../types/payload'

export const ScannerStore = types
  .model('ScannerStore')
  .props({
    assets: types.array(types.frozen<Asset>()),
    codes: types.array(types.frozen<Code>()),
    trackers: types.array(types.frozen<AssetTracker>()),
  })
  .volatile<ScannerStoreVolatileProps>(() => ({}))
  .actions(self => ({
    setAssets(assets: Asset[]) {
      self.assets.replace(assets)
    },
    addAsset(asset: Asset) {
      self.assets.push(asset)
    },
    removeAsset(asset: Asset) {
      self.assets.remove(asset)
    },
    setCodes(codes: Code[]) {
      self.codes.replace(codes)
    },
    addCode(code: Code) {
      self.codes.push(code)
    },
    removeCode(code: Code) {
      self.codes.remove(code)
    },
    setTrackers(trackers: AssetTracker[]) {
      self.trackers.replace(trackers)
    },
    addTracker(tracker: AssetTracker) {
      self.trackers.push(tracker)
    },
    removeTracker(tracker: AssetTracker) {
      self.trackers.remove(tracker)
    },
    reset() {
      this.setAssets([])
      this.setCodes([])
      this.setTrackers([])
      self.onEndFlowFn = undefined
    },
  }))
  .actions(self => ({
    startFlow(opts?: ScannerStoreVolatileProps) {
      self.reset()
      self.onEndFlowFn = opts?.onEndFlowFn
    },
    async endFlow() {
      await self.onEndFlowFn?.({
        assets: getSnapshot(self.assets),
        codes: getSnapshot(self.codes),
        trackers: getSnapshot(self.trackers),
      })
      self.reset()
    },
  }))

type Code = { identifier: string; type: 'qr' | 'nfc' }

export interface ScannerStoreVolatileProps {
  onEndFlowFn?: (data: { assets: Asset[]; codes: Code[]; trackers: AssetTracker[] }) => Promise<void> | void
}

export interface ScannerStore extends Instance<typeof ScannerStore> {}
export interface ScannerStoreSnapshot extends SnapshotOut<typeof ScannerStore> {}
